export const Url = {
  source: 'huawei',

  // 对象储存服务地址 层级 ====》 相当于项目路径
  ossHierarchy: process.env.VUE_APP_OSS_HIERARCHY,

  // 华为上传OBS    上传资源地址  // TODO 上传不需要 加载 bucketName
  huawei_upload: 'https://obs.cn-east-3.myhuaweicloud.com',

  // 华为sts获取鉴权地址
  huawei_res_url: 'https://sts.accfun.com/api/getCredential.html?',

  // 华为对象储存地址 OBS   下载资源地址   TODO   下载 需要加 bucketName
  huawei_source_host: process.env.VUE_APP_OBS_URL,

  // bucketName    ====》 大的层级
  ossBucketName: process.env.VUE_APP_OBS_BUCKET_NAME,

  // 后台接口请求地址
  ossRes: process.env.VUE_APP_OSS_RES,

  // 对象储存服务地址 华为obs or AliOss
  source_host: process.env.VUE_APP_OBS_URL,

  // 视频播放接口
  videoPrefix: 'https://rspm.accfun.com/vo.html?video',

  // 印章地址 放在其他资源路径下
  cacheUrl: process.env.VUE_APP_OBS_URL + '/apo',

  // ============项目路径配置========
  // 做题提交路径 上传 地址  在ts 文件中已定义配置文件和路径已定义好
  dshDataUrl: process.env.VUE_APP_OSS_HIERARCHY + '/ivData/testDetail/',

  // 华为source && 获取资源路径地址
  huawei_source: process.env.VUE_APP_OBS_URL + '/' + process.env.VUE_APP_OSS_HIERARCHY
}
export const environment = {
  // ========资源地址配置

  source: Url.source,
  // 华为OBS 下载地址
  source_host: Url.huawei_upload,
  // 层级
  ossHierarchy: Url.ossHierarchy,
  // 阿里Oss过期时间
  expirationDate: 30,
  // 华为鉴权过期时间
  huawei_expirationDate: 60,

  // bucketName
  ossBucketName: Url.ossBucketName,
  // 后台接口请求地址
  ossRes: Url.ossRes,
  // 华为source
  huawei_source: Url.huawei_source,

  ossDomain: Url.huawei_source,
  // ========================

  // =============与项目有关
  dshDataUrl: Url.dshDataUrl,

  videoPrefix: Url.videoPrefix,
  cacheUrl: Url.cacheUrl,
  // ========================
}
